/**
 * @description Types
 * @author      C. M. de Picciotto <d3p1@d3p1.dev> (https://d3p1.dev/)
 */
import * as THREE from 'three'
import type {RapierRigidBody} from '@react-three/rapier'
import * as React from 'react'

export interface Vec3 {
  x: number
  y: number
  z: number
}
export const CONTROL = {
  FORWARD: 'forward',
  RIGHTWARD: 'rightward',
  BACKWARD: 'backward',
  LEFTWARD: 'leftward',
  JUMP: 'jump',
  DEBUG: 'debug',
} as const
export type ActiveControl = (typeof CONTROL)[keyof typeof CONTROL]
export type ControlState = {
  [k in ActiveControl]: boolean
}
export type ArenaProps = {
  children: React.ReactNode
}
export type StageState = {
  geometry: THREE.BufferGeometry
  floorMaterial: THREE.MeshStandardMaterial
  floorTrapMaterial: THREE.MeshStandardMaterial
  trapMaterial: THREE.MeshStandardMaterial
  wallMaterial: THREE.MeshStandardMaterial
  trapCount: number
  isStarted: boolean
  isFinished: boolean
  startTime: number | null
  finishTime: number | null
  start: () => void
  finish: () => void
}
export type LevelProps = {
  position: [number, number, number]
}
export type TrapProps = LevelProps & {
  scale?: [number, number, number]
  update?: (
    time: number,
    body: RapierRigidBody,
    origin: [number, number, number],
  ) => void
}
export type Level = React.FC<LevelProps>
export type Trap = React.FC<TrapProps>

export type GameProps = {
  traps?: Level[]
}
export type Game = React.FC<GameProps>
export type Arena = React.FC<ArenaProps>
